import { render, staticRenderFns } from "./ResentContractComponent.vue?vue&type=template&id=751ca0cc&"
import script from "./ResentContractComponent.vue?vue&type=script&lang=js&"
export * from "./ResentContractComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports